import React from 'react';
import Pagination from 'rc-pagination';
import InputTag from "../Input-Tag/Input-Tag";
import './Images.scss';
import 'rc-pagination/assets/index.css';
import ImageCrop from '../Image-Crop/Image-Crop';
import { Configurations } from '../../Utils/Configurations';
import axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import ErrorModal from '../ErrorModal/ErrorModal';
class ImagesUpload extends React.Component {

    constructor(props) {
        super(props);
        this.selecionaImg = this.selecionaImg.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.toggleLayer = this.toggleLayer.bind(this);
        this.atualizaTags = this.atualizaTags.bind(this);
        this.salvarImg = this.salvarImg.bind(this);
        this.salvarImgGaleria = this.salvarImgGaleria.bind(this);
        this.toggleUploadImg = this.toggleUploadImg.bind(this);
        this.getImg = this.getImg.bind(this);
        this.habilitaSalvarImg = this.habilitaSalvarImg.bind(this);
        this.uploadArquivo = this.uploadArquivo.bind(this);
        this.buscaImagem = this.buscaImagem.bind(this);
        this.scrollImg = this.scrollImg.bind(this);
        this.toggleModalErrorUploadImg = this.toggleModalErrorUploadImg.bind(this);
        this.toggleEditar = this.toggleEditar.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.handleError = this.handleError.bind(this);
        this.atualizaTagsImgAlterada = this.atualizaTagsImgAlterada.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.erroValidacaoImg = this.erroValidacaoImg.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            paginaAtual: 1,
            qtdArtigos: 10,
            arrayImgs: [],
            urlImg: '',
            tags: [],
            uploadImg: true,
            titulo: '',
            descricao: '',
            temArquivo: false,
            isLoadingSalvar: false,
            buscaImg: '',
            nenhumaImg: false,
            openModalErrorUploadImg: false,
            imagemAlt: '',
            edicaoImagem: false,
            flagSucessoEdicaoImagem: false,
            isLoadingAlteracoes: false
        }

    }

    componentDidMount() {
        if (this.props.realizaBusca) {
            this.setState({
                buscaImg: this.props.urlImagemBusca
            })
            this.carregaImgs(null, false, true);
        }
    }

    selecionaImg(_img) {
        this.setState({
            flagSucessoEdicaoImagem: false,
            imagemAltImgAlterada: ''
        })
        const imgAlterada = {
            ..._img,
            tags: (!!_img.tags && _img.tags.length > 0) ?
                (_img.tags.length === 1 && _img.tags[0].length <= 0) ? [] : _img.tags
                : []
        }

        if (!this.state.isLoadingBusca) {
            this.setState({
                exibeImg: true,
                imgSelecionada: imgAlterada,
                nomeImgAlterada: imgAlterada.nomeImagem,
                descricaoImgAlterada: imgAlterada.descricao,
                tagsImgAlterada: imgAlterada.tags,
                imagemAltImgAlterada: imgAlterada.imagemAlt || "",
                idImgAlterada: imgAlterada.idImagem,
                edicaoImagem: false,
            }
                , () => this.scrollImg())
        }
    }

    scrollImg() {
        var element = document.getElementById("img-selecionada");
        element.scrollIntoView({ block: "start", behavior: "smooth" });
    }

    onChangePage(page) {
        this.setState({ paginaAtual: page, }, () => {
            this.carregaImgs();
        })
    }

    toggleLayer() { this.setState({ layer: this.state.layer === 1 ? 2 : 1 }) }

    atualizaTags(_tags) {
        this.setState({ tags: _tags })
    }

    atualizaTagsImgAlterada(_tags) {
        this.setState({ tagsImgAlterada: _tags })
    }


    async salvarImg() {
        const plat = this.props.plataforma || '';
        console.log("🚀 ~ ImagesUpload ~ salvarImg ~ this.state.crop:", this.state.crop)
        if (this.state.uploadImg) {

            var bodyFormData = new FormData();
            bodyFormData.append('nome', this.state.titulo);
            bodyFormData.append('tags', this.state.tags);
            bodyFormData.append('descricao', this.state.descricao);
            bodyFormData.append('imagem', this.state.imgAPI);
            bodyFormData.append('imageWidth', this.state.crop.width);
            bodyFormData.append('imageHeight', this.state.crop.height);
            bodyFormData.append('imagemAlt', this.state.imagemAlt);
            // bodyFormData.append('xCrop', this.state.crop.x);
            // bodyFormData.append('yCrop', this.state.crop.y);
            this.setState({ isLoadingSalvar: true, erroImg: false });
            await axios.post(this.Configurations.apiBasePath + `/imagem`, bodyFormData).then(response => {
                const _e = {
                    target: {
                        name: this.props.imgNoTexto ? "imagem-texto" : "imagem" + plat,
                        value: response.data.imagem.imagem.url,
                        alt: response.data.imagem.imagem.nomeImagem
                    }
                };
                this.props.onChangeInput(_e)
                this.props.toggle(null, this.props.plataforma);
                this.setState({ isLoadingSalvar: false })
            }).catch(err => {
                // this.toggleModalErrorUploadImg();
                this.setState({ isLoadingSalvar: false, erroImg: true })
            });
        }
        else {
            const _e = { target: { name: this.props.imgNoTexto ? "imagem-texto" : "imagem" + plat, value: this.state.urlImg } };
            this.props.onChangeInput(_e);
            this.props.toggle(null, this.props.plataforma);
        }
    }

    habilitaSalvarImg() {
        const _titulo = this.state.titulo.trim() !== '',
            _descricao = this.state.descricao.trim() !== '',
            _url = this.state.urlImg !== '';
        if (this.state.uploadImg) {
            return !(this.state.temArquivo * _titulo * _descricao);
        } else {
            return !(_titulo * _descricao * _url);
        }
    }

    toggleUploadImg(_valor) {
        this.setState({ uploadImg: _valor })
    }

    onChangeInput(e) {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value, edicaoImagem: true })
    }

    getImg(_crop, _croppedImg, _imgAPI) {
        console.log("🚀 ~ ImagesUpload ~ getImg ~ _crop, _croppedImg, _imgAPI:", _crop, _croppedImg, _imgAPI)
        this.setState({
            crop: _crop,
            croppedImg: _croppedImg,
            imgAPI: _imgAPI
        })
    }

    uploadArquivo() {
        this.setState({ temArquivo: true })
    }

    buscaImagem(e, pesquisa = null) {
        if (!!e) {
            e.preventDefault();
        }
        this.setState({
            arrayImgs: [],
            paginaAtual: 1
        }, () => {
            this.carregaImgs(pesquisa === "todas");
        })
    }

    carregaImgs(_todas = null, flagAtualizada, flagBuscaInicial) {
        this.setState({ isLoadingBusca: true }, () => {
            const _pesquisa = _todas ? '' : this.state.buscaImg;
            if (_todas) this.setState({ buscaImg: '' })
            axios.get(this.Configurations.apiBasePath + `/imagem?pagina=${this.state.paginaAtual}&qtd=12&pesquisa=${_pesquisa}`).then(response => {
                this.setState({
                    buscaImg: flagBuscaInicial ? '' : this.state.buscaImg,
                    layer: flagBuscaInicial ? (response.data.imagens.length > 0 ? 1 : 2) : 1,
                    arrayImgs: response.data.imagens,
                    exibeImg: flagAtualizada,
                    nenhumaImg: response.data.paginacao.qtdImagens <= 0,
                    paginaAtual: response.data.paginacao.pagina,
                    totalImgs: response.data.paginacao.qtdImagens,
                    isLoadingBusca: false,
                    buscaRealizada: !flagBuscaInicial

                }, () => {
                    if (this.state.arrayImgs.length > 0 && flagBuscaInicial) {
                        this.selecionaImg(this.state.arrayImgs[0]);
                    }
                })
            }).catch(err => {
                this.setState({ nenhumaImg: true, isLoadingBusca: false })
            });

        })
    }

    salvarImgGaleria() {
        const plat = this.props.plataforma || '';
        const _e = { target: { name: this.props.imgNoTexto ? "imagem-texto" : "imagem" + plat, value: this.state.imgSelecionada.url } };
        this.props.onChangeInput(_e)
        this.props.toggle(null, this.props.plataforma);
    }

    toggleModalErrorUploadImg() {

    }

    toggleEditar() {
        this.setState({ flagSucessoEdicaoImagem: !this.state.edicaoImagem ? false : this.state.flagSucessoEdicaoImagem }, () => { this.setState({ edicaoImagem: !this.state.edicaoImagem }) })
    }

    salvarAlteracoes() {
        this.setState({ isLoadingAlteracoes: true, flagSucessoEdicaoImagem: true })
        const _infosImagem = {
            idImagem: this.state.idImgAlterada,
            nomeImagem: this.state.nomeImgAlterada,
            descricao: this.state.descricaoImgAlterada,
            imagemAlt: this.state.imagemAltImgAlterada,
            tags: this.state.tagsImgAlterada
        }
        axios.post(this.Configurations.apiBasePath + `/imagem/atualizar`, _infosImagem).then(response => {
            this.toggleEditar();
            this.carregaImgs(null, true);


        }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
    }
    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    erroValidacaoImg(mensagemErro) {
        this.handleError({ response: { data: { message: mensagemErro } } });
    }

    render() {
        return (
            <div className="row no-gutters imagens">
                {this.state.layer === 1 ? (
                    <div className="col-12">
                        <div className="row no-gutters">
                            <div className="col-12 py-3">
                                <form className="form-inline row">
                                    <div className="form-group col-5">
                                        <input id="busca-img" name="buscaImg" className="mr-3 w-100 form-control text-left" type="text" value={this.state.buscaImg} onChange={this.onChangeInput} placeholder="Busca de imagem por palavras-chave" />
                                    </div>
                                    <div className="col-1 text-left px-0">
                                        <button disabled={this.state.isLoadingBusca || this.state.buscaImg === ''} onClick={this.buscaImagem} className="btn btn-outline-secondary mx-1">buscar</button>
                                    </div>
                                    <div className="col-3 text-right">
                                        <button onClick={(e) => this.buscaImagem(e, "todas")} className="btn btn-outline-primary mx-1">listar todas</button>
                                    </div>
                                    <div className="col-3 text-right">
                                        <button onClick={this.toggleLayer} className="btn btn-outline-info mx-1">voltar</button>
                                    </div>
                                </form>
                            </div>
                            <div className="col-12 px-2">
                                <div className="row no-gutters">
                                    {this.state.nenhumaImg && this.state.buscaRealizada && (
                                        <div className="offset-2 col-8 offset-lg-3 col-lg-6 text-center py-2 px-5 my-3">
                                            <small className="text-danger">Nenhuma imagem encontrada.</small>
                                        </div>
                                    )}
                                    {!this.state.isLoadingBusca && this.state.exibeImg && (
                                        <div className='row'>
                                            <div id="img-selecionada" className="col-4 text-center py-2 px-2 my-3 ">
                                                <div className="row no-gutters">
                                                    <div className="col-12 py-2">
                                                        <img className="img img-fluid w-100" src={this.state.imgSelecionada.url} alt="" />
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="row no-gutters">
                                                            <div className="col-12 text-center">
                                                                <small>{this.state.imgSelecionada.altura}x{this.state.imgSelecionada.largura}</small>
                                                            </div>
                                                            <div className="col-12 text-center">
                                                                <small><strong>{this.state.imgSelecionada.nomeImagem}</strong></small>
                                                            </div>
                                                            <div className="col-12 text-center">
                                                                <small>{this.state.imgSelecionada.descricao}</small>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-8 py-2 my-3'>
                                                <div className='row'>
                                                    <div className='col-12 py-3'>
                                                        <label>Título<sup><small>(*)</small></sup></label>
                                                        <input disabled={!this.state.edicaoImagem} name="nomeImgAlterada" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.nomeImgAlterada} autoComplete="off" />
                                                    </div>
                                                    <div className="col-12 col-lg-12 py-3">
                                                        <label htmlFor="descricao">Descrição<sup><small>(*)</small></sup></label>
                                                        <textarea disabled={!this.state.edicaoImagem} id="descricao" type="text" className="form-control" name="descricaoImgAlterada" value={this.state.descricaoImgAlterada} onChange={this.onChangeInput} />
                                                    </div>
                                                    <div className="col-12 py-3 tags-img">
                                                        <fieldset disabled={!this.state.edicaoImagem}>
                                                            <label>Tags</label>
                                                            <InputTag atualizaTags={this.atualizaTagsImgAlterada} tags={this.state.tagsImgAlterada} textInput={true} />
                                                        </fieldset>
                                                    </div>

                                                    <div className='col-12 text-left py-3'>
                                                        <label>Imagem alt</label>
                                                        <input disabled={!this.state.edicaoImagem} name="imagemAltImgAlterada" type="text" className="form-control" value={this.state.imagemAltImgAlterada} onChange={this.onChangeInput} autoComplete='off'></input>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 py-5 text-center">
                                                        {this.state.edicaoImagem ? (
                                                            <React.Fragment>
                                                                {!this.state.flagSucessoEdicaoImagem && (
                                                                    <div className="row">
                                                                        <div className="col-12 py-3">
                                                                            <span className="text-danger mr-3"><i>Para utilizar a imagem, salve as alterações.</i></span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <div className='row'>
                                                                    <div className='col-6'>
                                                                        <button disabled={this.state.edicaoImagem} onClick={this.salvarImgGaleria} className="btn btn-outline-info mx-1">utilizar imagem</button>
                                                                    </div>
                                                                    <div className='col-6 text-center'>
                                                                        {this.state.isLoadingAlteracoes ? (
                                                                            <div className="spinner-border text-primary " role="status" />
                                                                        ) : (
                                                                            <button className='btn btn-outline-success' onClick={this.salvarAlteracoes}>Salvar alterações</button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        ) : (
                                                            <React.Fragment>
                                                                {this.state.flagSucessoEdicaoImagem && (
                                                                    <div className="row">
                                                                        <div className="col-12 py-3 text-center">
                                                                            <span className="text-success mr-3"><i>Alterações salvas com sucesso.</i></span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <div className='row'>
                                                                    <div className='col-6'>
                                                                        <button disabled={this.state.edicaoImagem} onClick={this.salvarImgGaleria} className="btn btn-outline-info mx-1">utilizar imagem</button>
                                                                    </div>
                                                                    <div className='col-6'>
                                                                        <button className='btn btn-outline-success' onClick={this.toggleEditar}>Editar informações</button>
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        )}
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    )}

                                    <div className={`offset-1 col-10 py-3 ${this.state.isLoadingBusca ? 'div-opacity' : ''}`}>
                                        <div className="row">
                                            {this.state.arrayImgs.length > 0 && this.state.arrayImgs.map((img, index) => {
                                                return (
                                                    <div key={`img-${index}`} className="col-3 px-2 py-2 img-galeria  align-items-center">
                                                        <div className="row no-gutters">
                                                            <div onClick={() => this.selecionaImg(img)} className="col-12 px-1 py-1 pointer">
                                                                <img className="w-100 img-fluid img" src={img.url} alt="img" />
                                                                <strong><p className='m-0 text-center text-truncate'>{img.nomeImagem}</p></strong>
                                                                <p className='m-0 text-center text-truncate'>{img.descricao}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        {this.state.arrayImgs.length > 0 && (
                                            <div className="paginacao">
                                                <Pagination onChange={this.onChangePage} current={this.state.paginaAtual} total={this.state.totalImgs} pageSize={12} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <div className="row no-gutters">
                                    <div className="col-12 col-lg-6 text-center text-lg-right py-2 order-1 order-lg-3">
                                        <button onClick={this.toggleLayer} className="btn btn-outline-info">galeria de imagens</button>
                                    </div>
                                    <div className="col-6 col-lg-3 py-2 text-left order-2 order-lg-1">
                                        <button onClick={() => this.toggleUploadImg(true)} className={`${this.state.uploadImg ? `btn btn-secondary border border-secondary` : 'btn btn-outline-secondary'}`}>carregar arquivo</button>
                                    </div>
                                    <div className="col-6 col-lg-3 px-2 py-2 text-left order-3 order-lg-2">
                                        <button onClick={() => this.toggleUploadImg(false)} className={`${!this.state.uploadImg ? `btn btn-secondary border border-secondary` : 'btn btn-outline-secondary'}`}>imagem via URL</button>
                                    </div>
                                </div>
                            </div>
                            {this.state.uploadImg && (
                                <div className="col-12 text-center">
                                    <ImageCrop getImg={this.getImg} uploadArquivo={this.uploadArquivo} erroValidacaoImg={this.erroValidacaoImg} />
                                </div>
                            )}
                            <div className="col-12 col-lg-12 py-3">
                                <small><small>(*)</small> informações obrigatórias</small>
                            </div >
                            {this.state.urlImg !== '' && (
                                <div className="col-12 col-lg-12 py-3">
                                    <img className="img img-fluid" src={this.state.urlImg} alt="" />
                                </div>
                            )}
                            {!this.state.uploadImg && (
                                <div className="col-12 col-lg-12 py-3">
                                    <label>URL da imagem<sup><small>(*)</small></sup></label>
                                    <input name="urlImg" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.urlImg} autoComplete="off" />
                                </div>
                            )}
                            <div className="col-12 col-lg-6 py-3">
                                <label>Título<sup><small>(*)</small></sup></label>
                                <input name="titulo" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.titulo} autoComplete="off" />
                            </div>
                            <div className='col-6 text-left py-3'>
                                <label>Imagem alt</label>
                                <input name="imagemAlt" type="text" className="form-control" value={this.state.imagemAlt} onChange={this.onChangeInput} autoComplete='off'></input>
                            </div>
                            <div className="col-12 col-lg-12 py-3">
                                <label htmlFor="descricao">Descrição<sup><small>(*)</small></sup></label>
                                <textarea id="descricao" type="text" className="form-control" name="descricao" value={this.state.descricao} onChange={this.onChangeInput} />
                            </div>
                            <div className="col-12 py-3 tags-img">
                                <label>Tags</label>
                                <InputTag atualizaTags={this.atualizaTags} tags={this.state.tags} textInput={true} />
                            </div>

                            {this.state.isLoadingSalvar ? (
                                <div className="col-12 text-center py-2">
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            ) : (
                                <div className="col-12 text-center py-2">
                                    {this.state.erroImg && (
                                        <p className="text-danger">{this.state.errorMessage}</p>
                                    )}
                                    <button disabled={this.habilitaSalvarImg()} onClick={this.salvarImg} className="btn btn-outline-success">salvar imagem</button>
                                </div>
                            )}
                        </div>
                    </div>
                )
                }
                <Modal isOpen={this.state.modalErrorUploadImg} toogle={this.toggleModalErrorUploadImg}>
                    <ModalHeader toggl={this.toggleModalErrorUploadImg}>Ops.. ocorreu um erro!</ModalHeader>
                    <ModalBody>
                        Não foi possível salvar a imagem.
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary">ok</Button>
                    </ModalFooter>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />


            </div>
        );
    }
}

export default ImagesUpload;